import React from 'react';
import './Episodes.css';

const Episodes=()=> {
  const episodes=[
    {
      id: 1,
      number: 'EPISODE 01',
      title: 'Creative discipline in a distracted world',
      teaser: 'How to stay focused and maintain artistic integrity when everything is fighting for your attention.',
      guest: 'Guest: Creative Professional',
      duration: '45 min',
      videoId: 'nBJNkS3Sf_Q'
    },
    {
      id: 2,
      number: 'EPISODE 02',
      title: 'Building when no one believes yet',
      teaser: 'The journey of entrepreneurship when you\'re the only one who sees the vision clearly.',
      guest: 'Guest: Startup Founder',
      duration: '52 min',
      videoId: 'Y-9yWjyWqN0'
    },
    {
      id: 3,
      number: 'EPISODE 03',
      title: 'Perspective that shapes culture',
      teaser: 'How individual viewpoints can collectively influence and transform cultural landscapes.',
      guest: 'Guest: Cultural Commentator',
      duration: '38 min',
      videoId: 'kAvoEX-Q3D0'
    }
  ];

  return (
    <section id="episodes" className="episodes">
      <div className="episodes-container">
        <div className="episodes-header">
          <h2 className="episodes-title">Latest Episodes</h2>
          <p className="episodes-subtitle">
            Real people. Real lessons. Every episode leaves you thinking and growing.
          </p>
        </div>
        <div className="episodes-grid">
          {episodes.map((episode)=> (
            <div key={episode.id} className="episode-card hover-lift">
              <div className="episode-thumbnail">
                <iframe 
                  width="100%" 
                  height="100%" 
                  src={`https://www.youtube.com/embed/${episode.videoId}?si=${episode.id===1 ? 'Ys6dM5-JOUe_UD6I' : episode.id===2 ? 'PAOaSp2aP9mrN75D' : 'Lv63H_-jkSBrodCX'}&controls=0`} 
                  title={`Point Makers Podcast ${episode.number} - ${episode.title}`}
                  frameBorder="0" 
                  allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen 
                  className="video-embed"
                  loading="lazy"
                />
              </div>
              <div className="episode-link-container">
                <a href={`https://youtube.com/watch?v=${episode.videoId}`} className="episode-link" target="_blank" rel="noopener noreferrer">
                  Watch Full Episode → YouTube
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="episodes-actions">
          <a href="https://youtube.com/@pointmakerspodcast?si=khoIm_WB-cYQAAql" className="btn-primary" target="_blank" rel="noopener noreferrer">
            Watch All Episodes on YouTube
          </a>
          <a href="https://open.spotify.com/show/1wPc9jHtjXOIjAcKoB9vqh?si=0b631c92d07740d7&nd=1&dlsi=1ab69a7e63ea4987" className="btn-secondary" target="_blank" rel="noopener noreferrer">
            Listen on Spotify
          </a>
        </div>
      </div>
    </section>
  );
};

export default Episodes;